export default __webpack_public_path__ + "static/media/solution_64.cf3e03ae.svg";